<template>
  <div class="conteudo-modal">
    <div  id="app-bpmn">
      <div id="bpmn-container"></div>
    </div>
    <div class="informacao">
      <div class="passou box"><p class="texto-white">Setor pelo qual o processo já passou</p></div>
      <div class="pendente box"><p class="texto-black">Setor pelo qual o processo ainda não passou</p></div>
      <div class="atual box"><p class="texto-white">Setor atual</p></div>
    </div>
  </div>
</template>

<script>
import axios from '@/utils/api'
import BpmnViewer from 'bpmn-js/lib/NavigatedViewer'
import 'bpmn-js/dist/assets/bpmn-font/css/bpmn-embedded.css'

export default {
  name: 'BpmnViewer',
  props: ['numeroProcesso', 'tipoProcesso'],
  data () {
    return {
      bpmnXml: null,
      fluxos: null
    }
  },
  async mounted () {
    await this.loadXML()
    await this.renderBpmn()
  },
  methods: {
    async loadXML () {
      const { xml, fluxosProcesso } = await axios({
        method: 'get',
        url: `fluxoXml/xml?numeroProcesso=${this.numeroProcesso}&tipoProcesso=${this.tipoProcesso}`
      })

      this.bpmnXml = xml
      this.fluxos = fluxosProcesso
    },
    async renderBpmn () {
      const container = await document.getElementById('bpmn-container')

      const viewer = new BpmnViewer({
        container: container
      })

      // Carregue o XML do fluxo e renderize-o
      await viewer.importXML(this.bpmnXml, (err, definitions) => {
        if (err) {
          console.error('Erro ao renderizar o XML do fluxo:', err)
        } else {
          // Ajuste a escala do diagrama para se adequar ao contêiner
          const canvas = viewer.get('canvas')
          canvas.zoom(0.6)
          let setorAtual = false

          const elementsCollection = document.getElementsByClassName('djs-element')
          for (let i = 0; i < elementsCollection.length; i++) {
            const element = elementsCollection[i]
            const elementId = element.getAttribute('data-element-id')

            let elements = document.getElementsByTagName('rect')

            for (let i = 0; i < elements.length; i++) {
              let rectElement = elements[i]
              let width = rectElement.getAttribute('width')
              if (parseInt(width) === 14) {
                rectElement.remove()
              }
            }

            let icones = document.getElementsByTagName('path')

            for (let i = 0; i < icones.length; i++) {
              let rectElement = icones[i]
              let data = rectElement.getAttribute('data-marker')
              if (data === 'sub-process') {
                rectElement.remove()
              }
            }

            if (this.fluxos.find(f => f.idFluxo === elementId) && !element.getAttribute('class').includes('djs-connection')) {
              const rectElement = element.querySelector('rect')
              const textElement = element.querySelector('text')
              const g = element.querySelector('g')

              if (rectElement && !g.querySelector('polygon') && !g.querySelector('circle') && this.fluxos.find(f => f.idFluxo === elementId)) {
                rectElement.style.fill = 'rgb(134, 134, 134)'
                rectElement.style.stroke = 'rgb(134, 134, 134)'
              }
              if (textElement && !g.querySelector('polygon') && !g.querySelector('circle')) {
                textElement.style.fill = 'white'
              }
              if (rectElement && !g.querySelector('polygon') && !g.querySelector('circle') && this.fluxos[this.fluxos.length - 1].idFluxo === elementId) {
                setorAtual = true
                rectElement.style.fill = 'rgb(40, 159, 97)'
                rectElement.style.stroke = 'rgb(40, 159, 97)'
              }
            }
          }
          if (!setorAtual && this.fluxos.length > 0) {
            let rectStyle = null
            let maiorIndex = -1 // Inicialize com um valor menor do que qualquer índice possível
            for (let i = 0; i < elementsCollection.length; i++) {
              const element = elementsCollection[i]
              const elementId = element.getAttribute('data-element-id')

              if (this.fluxos.find(f => f.idFluxo === elementId) && !element.getAttribute('class').includes('djs-connection')) {
                const rectElement = element.querySelector('rect')
                const g = element.querySelector('g')
                if (rectElement && !g.querySelector('polygon') && !g.querySelector('circle')) {
                  const currentIndex = this.fluxos.findIndex((f) => f.idFluxo === elementId)
                  // Verifica se o idFluxo não contém a palavra "ARQUIVAMENTO"
                  if (currentIndex > maiorIndex && !this.fluxos[currentIndex].idFluxo.includes('ARQUIVAMENTO')) {
                    maiorIndex = currentIndex
                    rectStyle = rectElement
                  }
                }
              }
            }
            if (rectStyle) {
              rectStyle.style.fill = 'rgb(40, 159, 97)'
              rectStyle.style.stroke = 'rgb(40, 159, 97)'
            }
          }
        }
      })
    }
  }
}
</script>
<style scoped>

#bpmn-container {
  width: 100%;
  height: 530px;
}

#app-bpmn {
  width: 100%;
  height: 510px;
}

#pane-VISUALIZAR_FLUXO {
  height: 500px !important;
}

.bpmn-highlight {
  background-color: green !important
}

.box {
  width: 130px;
  height: 60px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  margin: 5px;
}

.pendente {
  background-color: rgb(255, 255, 255);
  border: 3px solid black;
}

.texto-white {
  color: rgb(255, 255, 255) !important;
  font-size: 10px;
}

.texto-black {
  color: rgb(3, 3, 3) !important;
  font-size: 10px;
}

.conteudo-modal {
  position: relative;
}

.informacao {
  position: absolute;
  top: 0;
  right: 10px;
  box-sizing: border-box;
}

.passou {
  background-color: rgb(134, 134, 134);
  border: 3px solid rgb(134, 134, 134);
}

.atual {
  background-color: rgb(40, 159, 97);
  border: 3px solid rgb(40, 159, 97);
}
</style>



// WEBPACK FOOTER //
// src/components/AppBpmnViewer.vue